import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import { getHomrPageType, getImageDataFromHomrResponse } from '../../utility/utils';
import { getHomrBannerUrl } from '../../utility/url-utils';
import ImageBanner from './ImageBanner/ImageBanner';
import HeroBanner from './HeroBanner/HeroBanner';

const Banner = ({ isFamilyPage, breakpoint, chain }) => {
  const [bannerContent, setBannerContent] = useState(null);

  useEffect(() => {
    // Get homR Banner image
    const getHomrBanner = async () => {
      let response = null;

      if (isFamilyPage) {
        const host = typeof window !== 'undefined' && window.location ? window.location.host : '';
        const isValidHost =
          host.includes('dickssportinggoods') ||
          host.includes('golfgalaxy') ||
          host.includes('fieldandstreamshop') ||
          host.includes('calia') ||
          host.includes('vrst') ||
          host.includes('publiclands') ||
          host.includes('moosejaw') ||
          host.includes('goinggoinggone') ||
          host.includes('qa6.dksxchange');

        response = await Axios.get(
          `${getHomrBannerUrl(isValidHost)}${getHomrPageType(isFamilyPage)}&chain=${chain}`,
        );
      }

      if (
        response &&
        response.data &&
        response.data.content['hero_v2'] &&
        response.data.content['hero_v2'][0]
      ) {
        const imageData = getImageDataFromHomrResponse(response.data.content['hero_v2'][0]);
        setBannerContent({
          ...response.data.content['hero_v2'][0],
          structuredImageData: imageData,
          type: 'Hero Banner',
        });
      } else if (
        response &&
        response.data &&
        response.data.content['Image Banner'] &&
        response.data.content['Image Banner'][0]
      ) {
        const imageData = getImageDataFromHomrResponse(response.data.content['Image Banner'][0]);
        setBannerContent({
          ...response.data.content['Image Banner'][0],
          structuredImageData: imageData,
          type: 'Image Banner',
        });
      }
    };

    // Call Homr Banner API on Component Mount
    getHomrBanner();
  }, []);

  try {
    if (
      bannerContent &&
      bannerContent.structuredImageData &&
      bannerContent.type === 'Image Banner'
    ) {
      return <ImageBanner content={bannerContent} breakpoint={breakpoint} />;
    } else if (
      bannerContent &&
      bannerContent.structuredImageData &&
      bannerContent.type === 'Hero Banner' &&
      (chain === 'pl' || chain === 'mj')
    ) {
      return <HeroBanner content={bannerContent} breakpoint={breakpoint} />;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

export default Banner;
